
export default {
    name: 'SvgMagnifyingGlass',
    props: {
        color: {
            type: String,
            default: '#312F2A',
        },
    },
};
